import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { TOKEN_KEYS } from './Util/Util';

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const isAuthenticated = useSelector((state) => state.user?.user?.jwtToken);
  const tokenFromLocal = localStorage.getItem(TOKEN_KEYS.JWT);
  const hasToken = isAuthenticated || tokenFromLocal;
  const location = useLocation();

  // Wait for authentication check to complete before rendering
  useEffect(() => {
    setLoading(false);
  }, [isAuthenticated, tokenFromLocal]);

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a loading spinner
  }

  // Enforce the rule where if the location is "/", bypass the authentication check
  return hasToken
    ? location.pathname !== "/" // If the user is authenticated and not on "/"
      ? children // Render the children if they are authenticated and not on "/"
      : <Navigate to="/"/> // Redirect to "/" if they are authenticated and on "/"
    : <Navigate to="/"/>; // Redirect to "/" if they are not authenticated
};

export default ProtectedRoute;
